import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgSchemaNodeCard } from "../../../molecules/KgSchemaNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const SchemaFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgSchemaNodeCard
      title={data.title ?? ""}
      subtitle={data.subtitle}
      logoUrl={data.logoUrl}
      iconColor={data.iconColor}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default SchemaFlowNode;
